export const ANALYTICS_CURRENCY = 'PEN';
export const ANALYTICS_CHANNEL = 'web';
export const ANALYTICS_AFFILIATION = 'Luxury Club Web';

export const LUXURY_GTM_CONTAINER_ID = 'GTM-MBZRJ7GB';

export type UserSegment =
  | 'SEGMENTO_GENERAL'
  | 'INFINITE_CLIENTES_NUEVOS'
  | 'PREMIUM_CLIENTES_NUEVOS'
  | 'PREMIUM_CLIENTES_ACTUALES'
  | 'INFINITE_CLIENTES_ACTUALES';
export type AcquisitionSource = 'email' | 'meta' | 'organic' | 'direct';
export type BuyerStatus = 'new' | 'returning' | 'lapsed';
export type DeviceType = 'desktop' | 'mobile' | 'tablet';
export type DocumentType = 'DNI' | 'CE';
export type LoginErrorType = 'not_found' | 'technical' | 'timeout';
export type PasswordPopupTriggerContext = 'item_list' | 'view_item' | 'cart' | 'profile';
export type PasswordPopupDismissMethod = 'close_button' | 'click_outside' | 'escape';
export type AddToCartSurface = 'item_list' | 'view_item' | 'home' | 'modal';
export type PaymentDeclineReason =
  | 'cvv_invalid'
  | 'card_expired'
  | 'insufficient_funds'
  | 'antifraud'
  | 'minimum_amount'
  | 'gateway_error'
  | 'declined';
export type CheckoutErrorType =
  | PaymentDeclineReason
  | 'payment_declined'
  | 'timeout'
  | 'validation'
  | 'technical';
export type CheckoutErrorStep = 'cart' | 'shipping' | 'payment' | 'confirmation';

export interface AnalyticsUserProperties {
  readonly user_id: string;
  readonly user_segment: UserSegment | '';
  readonly user_channel: typeof ANALYTICS_CHANNEL;
  readonly acquisition_source: AcquisitionSource;
  readonly buyer_status: BuyerStatus | '';
}

export interface AnalyticsItem {
  readonly item_id: string;
  readonly item_name: string;
  readonly item_brand: string;
  readonly item_category: string;
  readonly price: number;
  readonly quantity?: number;
  readonly index?: number;
  readonly price_regular?: number;
  readonly item_list_id?: string;
  readonly item_list_name?: string;
}

/** Purchase payload pieces saved at place_order so a fresh page load can still send purchase. */
export interface AnalyticsPendingPurchase {
  readonly items: AnalyticsItem[];
  readonly value: number;
  readonly shipping: number;
  readonly currency: string;
  readonly payment_type: string;
}

export interface AnalyticsPageView {
  readonly page_path: string;
  readonly page_location: string;
  readonly page_title: string;
}

export interface AnalyticsShippingInfo {
  readonly shippingCost: number;
  readonly shippingTime: string;
  readonly sellers: readonly string[];
}

export interface AnalyticsOrderTotals {
  readonly total?: number;
  readonly shipping?: number;
}

export interface AnalyticsItemInput {
  readonly id?: string | null;
  readonly sku?: string | null;
  readonly name?: string | null;
  readonly title?: string | null;
  readonly brand?: string | null;
  readonly brandName?: string | null;
  readonly category?: string | null;
  readonly price?: number | null;
  readonly luxuryPrice?: number | null;
  readonly memberPrice?: number | null;
  readonly regularPrice?: number | null;
  readonly quantity?: number | null;
  readonly index?: number | null;
}

export interface AnalyticsAttribution {
  readonly source: string;
  readonly medium: string;
  readonly campaign: string;
  readonly acquisitionSource: AcquisitionSource;
}
